import { render, staticRenderFns } from "./studentFiles.vue?vue&type=template&id=9caaa6a6&scoped=true"
import script from "./studentFiles.vue?vue&type=script&lang=js"
export * from "./studentFiles.vue?vue&type=script&lang=js"
import style0 from "./studentFiles.vue?vue&type=style&index=0&id=9caaa6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caaa6a6",
  null
  
)

export default component.exports